import { render, staticRenderFns } from "./PortfolioDataroom.vue?vue&type=template&id=8aadfc48&scoped=true"
import script from "./PortfolioDataroom.vue?vue&type=script&lang=js"
export * from "./PortfolioDataroom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aadfc48",
  null
  
)

export default component.exports